module.exports = __webpack_public_path__ + "img/SunleiGraduate.9141ff65.png";